import React, { useCallback, useEffect, useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import { Text, Card, Toast, ChoiceList, Page, PageActions, TextField, Layout, Banner, List, Frame, Select, Icon, Checkbox, Form, DropZone, Thumbnail, Stack, FormLayout, Button } from '@shopify/polaris';
import { MobileBackArrowMajor } from '@shopify/polaris-icons';
import SearchProduct from '../../upsell/SearchProduct';
import Preview from '../../plans/Preview';

const CreatePointsProgramFaq = (props) => {
    const { domain, faqFormData, setFaqFormData, index, faqFieldErrors, setFaqFieldErrors, i18n } = props;
    const [toastContent, setToastContent] = useState("");
    const [toastActive, setToastActive] = useState(false);
    const toggleToastActive = useCallback(() => setToastActive((toastActive) => !toastActive), []);

    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    const [fieldError, setFieldError] = useState({ title: '', bodyHtml: '' });

    const handleChange = (val, key) => {
        let data = faqFormData;
        data[index][key] = val;
        setFaqFormData([...data]);
        if (val) {
            let errors = faqFieldErrors;
            errors.splice(index, 1)
            setFaqFieldErrors([...errors])
        }
    }

    return (
        <Layout>
            <Layout.Section>
                <Card sectioned>
                    <Form>
                        <FormLayout>
                            <FormLayout.Group>
                                <TextField
                                    label={i18n.t("title")}
                                    type="text"
                                    value={`${faqFormData?.[index]?.title}`}
                                    onChange={(e) => {
                                        handleChange(e, "title")
                                    }}
                                    error={faqFieldErrors[index]?.title}
                                    autoComplete="off"
                                />
                            </FormLayout.Group>

                            <FormLayout.Group>
                                <TextField
                                    label={i18n.t("body_html")}
                                    type="text"
                                    multiline={4}
                                    value={`${faqFormData?.[index]?.bodyHtml}`}
                                    onChange={(e) => {
                                        handleChange(e, "bodyHtml")
                                    }}
                                    error={faqFieldErrors[index]?.bodyHtml}
                                    autoComplete="off"
                                />
                            </FormLayout.Group>
                        </FormLayout>
                    </Form>
                </Card>
            </Layout.Section>
        </Layout>

    )
}

export default CreatePointsProgramFaq;